import { getUserCreds, socket } from "@/utils/utils"
import { useEffect, useRef, useState } from "react"
import io from "socket.io-client"
import { MainButton } from "./MainButton"
import { useNavigate } from "react-router-dom"
import ModalButton from "./ModalButton"
import { useAppSelector } from "@/store/hooks"

const VoiceChat = ({ roomId }: { roomId: string }) => {
  const myGame = useAppSelector((state) => state.global.myGame)

  const nav = useNavigate()

  // return null
  return (
    <div className="fixed z-[20]">
      {/* <h3>Voice Chat</h3> */}
      {/* {isConnected ? <p>Connected</p> : <p>Connecting...</p>} */}
      <div className="fixed text-white bottom-[calc(2.5rem+var(--safe-bottom))]  right-[calc(1rem+var(--safe-right))] gap-4 flex">
        {/* <MainButton onClick={toggleMic} className=" w-10 h-10 ">
          <i
            className={`fa-solid fa-lg ${
              micEnabled ? "fa-microphone" : "fa-microphone-slash"
            }`}
          ></i>
        </MainButton> */}

        {/* Toggle Speaker */}
        {/* <MainButton onClick={toggleSpeaker} className="w-10 h-10 ">
          <i
            className={`fa-solid fa-lg ${
              speakerEnabled ? "fa-volume-up" : "fa-volume-mute"
            }`}
          ></i>
        </MainButton> */}
      </div>
    </div>
  )
}

export default VoiceChat
